import { useRef } from "react";

const usePreventScroll = () => {
    const scrollY = useRef(0);

    const storeScrollPosition = () => {
        scrollY.current = window.scrollY;
    };

    const restoreScrollPosition = () => {
        requestAnimationFrame(() => {
            window.scrollTo(0, scrollY.current);
        });
    };

    return { storeScrollPosition, restoreScrollPosition };

}

export default usePreventScroll;